module.exports = __webpack_public_path__ + "fonts/VetoSansCond-CondLight.3197172b.woff";